/*
 * Filtros: envia o formulário sozinho a cada mudança, e fecha o painel aberto
 * ao clicar fora.
 *
 * O formulário funciona sem isto — é um GET normal com botão "Aplicar" dentro
 * de <noscript>. Aqui só tiramos o passo extra de quem tem JavaScript.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-yasy-facets]');
  if (!form) return;

  var enviando = false;

  function enviar() {
    if (enviando) return;
    enviando = true;
    /* requestSubmit respeita validação e o `formmethod`; submit() não. */
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  }

  /* Campos de preço não podem enviar a cada tecla digitada: espera a pessoa
     parar de digitar, ou sair do campo. */
  var espera;
  form.addEventListener('input', function (e) {
    if (e.target.type !== 'number') return;
    clearTimeout(espera);
    espera = setTimeout(enviar, 700);
  });

  form.addEventListener('change', function (e) {
    if (e.target.type === 'number') { clearTimeout(espera); }
    enviar();
  });

  /* Um painel por vez, e fecha ao clicar fora — senão os menus ficam
     empilhados sobre a grade. */
  var paineis = form.querySelectorAll('[data-yasy-facet]');
  Array.prototype.forEach.call(paineis, function (p) {
    p.addEventListener('toggle', function () {
      if (!p.open) return;
      Array.prototype.forEach.call(paineis, function (outro) {
        if (outro !== p) outro.open = false;
      });
    });
  });

  document.addEventListener('click', function (e) {
    Array.prototype.forEach.call(paineis, function (p) {
      if (p.open && !p.contains(e.target)) p.open = false;
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(paineis, function (p) { p.open = false; });
  });
})();
